import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, TextField } from '@mui/material';

import { Area } from '@/types';
import { useUpdateAreaMutation } from '@/services';
import { messages } from '@/utils/helpers';

export interface UpdateAreaProps extends DialogProps {
  area: Area;
  onClose(): void;
}

const UpdateArea: React.FC<UpdateAreaProps> = ({ area, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [updateArea, updateAreaResponse] = useUpdateAreaMutation();

  const { values, errors, touched, handleSubmit, handleChange } = useFormik<Area>({
    initialValues: area ?? {
      name: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      name: yup.string().required(messages.form.REQUIRED),
    }),
    async onSubmit(area, { resetForm }) {
      try {
        await updateArea(area).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        enqueueSnackbar(error.data, { variant: 'error' });
      }
    },
  });

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">Редактировать район</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="name"
                label="Наименование"
                placeholder="Введите значение"
                value={values.name}
                onChange={handleChange}
                disabled={updateAreaResponse.isLoading}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name ? errors.name : ''}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            disabled={updateAreaResponse.isLoading}
            onClick={onClose}
          >
            Закрыть
          </Button>

          <Button type="submit" variant="contained" disabled={updateAreaResponse.isLoading}>
            Редактировать
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default UpdateArea;
